import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AirportShuttle from "@material-ui/icons/AirportShuttle";
import DoneIcon from "@material-ui/icons/Done";
import DonutSmall from "@material-ui/icons/DonutSmall";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import ListAltIcon from "@material-ui/icons/ListAlt";
import SyncAlt from "@material-ui/icons/SyncAlt";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemIcon={<DonutSmall />}
      header={t("lifeCycleManagement.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/production");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <ListAltIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.production")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/transferlist");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SyncAlt />
        </ListItemIcon>
        <ListItemText primary={t("transferList.header")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/transfers");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <AirportShuttle />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.transfers")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/demos");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <EmojiTransportationIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.demos")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/dispatches");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <DoneIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.dispatches")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
